import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { messages } from "./languages";

// Idioma: espanol por defecto.
//
// Si el usuario eligio otro idioma a proposito, se respeta. EXCEPCION: las
// instalaciones que vienen del sistema original quedaron con "pt-BR" guardado
// en el navegador sin que nadie lo eligiera. Esa preferencia se migra a
// espanol una sola vez; si no, el selector seguiria mostrando la bandera de
// Brasil para siempre a quien ya habia entrado antes, aunque la interfaz este
// en espanol.
let detectedLng = "es";
try {
  const guardado = localStorage.getItem("i18nextLng");
  if (guardado === "pt" || guardado === "pt-BR") {
    localStorage.setItem("i18nextLng", "es");
  } else if (guardado) {
    detectedLng = guardado;
  }
} catch (e) {
  // localStorage bloqueado (incognito o privacidad estricta): se queda espanol
}

i18n
  .use(initReactI18next)
  .init({
    debug: false,
    lng: detectedLng,
    fallbackLng: "es",
    defaultNS: ["translations"],
    ns: ["translations"],
    resources: messages,
  });

// Salvar mudança de idioma quando possível
i18n.on("languageChanged", (lng) => {
  try {
    localStorage.setItem("i18nextLng", lng);
  } catch (e) {
    // storage bloqueado, ignora
  }
});

export { i18n };
